import React from 'react';
import {API} from 'aws-amplify';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {updateNewTransferCreation} from 'redux/actions/transfers_2';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import customCheckboxRadioSwitch from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx';
import {cardTitle} from 'assets/jss/material-dashboard-pro-react';
import queryString from 'query-string';
import cardPng from 'assets/img/payment_24px.png';
import CommoneCurrentComponent from '../../../common/Common';
import axios from 'axios';
import {Checkbox, Chip, Divider, FormControlLabel} from '@material-ui/core';
import Check from '@material-ui/icons/Check';

const style = {
  ...customCheckboxRadioSwitch,
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    '& small': {
      fontSize: '80%',
      fontWeight: '400'
    }
  },
  infoText: {
    fontWeight: '300',
    margin: '10px 0 30px',
    textAlign: 'center'
  },
  inputAdornmentIcon: {color: '#555'},
  inputAdornment: {position: 'relative'},
  formControl: {
    minWidth: 120,
    padding: '0 !important'
  },
  selectControl: {
    backgroundColor: '#00BDAB !important',
    color: 'white',
    padding: '5%',
    width: '100% !important'
  },
  optionStyle: {backgroundColor: '#00BDAB !important'},

  column: {
    paddingRight: '0 !important',
    paddingBottom: '0 !important'
  },
  columnRight: {paddingLeft: '0 !important'},
  boxShadow: {
    filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
    boxSizing: 'border-box'
  },
  input: {
    margin: 0,
    padding: 0,
    border: 'none',
    direction: 'rtl',
    paddingRight: '4%',
    fontWeight: '700',
    fontFamily: 'Roboto',
    fontSize: '24px'
  },
  divv: {
    filter: 'drop-shadow(2px 4px 4px rgba(0, 0, 0, 0.25))',
    boxSizing: 'border-box'
  },
  pp: {
    float: 'right',
    paddingRight: '9px',
    padding: '0',
    margin: '0',
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '12px',
    paddingTop: '1px'
  },
  iso: {fontSize: '13px !important'},
  isoSpan: {width: '33% !important'},
  textArea: {
    backgroundColor: 'white',
    width: '100%'
  },
  inputReadOnly: {
    paddingTop: '4px',
    zIndex: '-1000',
    paddingRight: '4%',
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '13px',
    margin: 0,
    padding: 0,
    paddingBottom: '0',
    border: 'none',
    direction: 'rtl'
  },
  transferRate: {
    fontFamily: 'Roboto',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '2px',
    paddingLeft: '4%',
    color: '#131313',
    paddingTop: '3%',
    textTransform: 'uppercase'
  },
  selectContainer: {
    padding: '4%',
    background: '#FFFFFF',
    border: '1px solid #0BACF4',
    boxSizing: 'border-box',
    borderRadius: '6px'
  },
  paymentMethod: {
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '17.04px',
    float: 'right',
    textAlign: 'right',
    opacity: '0.7',
    color: '#131313',
    paddingTop: '4%',
    paddingRight: '3%'
  },
  cardImg: {
    textAlign: 'center',
    paddingLeft: '7% !important'
  },
  transactionOptions: {
    border: 'none',
    width: '100%',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '2px',
    textAlign: 'right',
    letterSpacing: '0.15em',
    textTransform: 'uppercase',
    color: '#0BACF4',
    backgroundColor: 'white'
  }
};

const min_transfer_amount = 0;
const WORLDPAY_ADJUSTMENT = 0.02;

class Step2Transfer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      from_currency: 'AUD',
      to_currency: 'USD',
      from_amount: '1000',
      to_amount: '',
      reRender: true,
      from_currency_state: 'error',
      to_currency_state: 'error',
      from_amount_state: 'error',
      to_amount_state: 'error',
      holdingAccount: null,
      beneficiaries_list: [],
      beneficiary_id: '',
      beneficiary: {},
      purpose_of_payment_detail_state: '',
      amount_to_state: '',
      currencies_list: [],
      currencies_list_priority: []
    };
  }

  componentDidMount() {
    API.get('currencies', '/list_not_deleted')
      .then(response => {
        this.setState({currencies_list_priority: response}, () => {
          this.queryStrings();
        });
      })
      .catch(error => {
        console.log(error);
      });

    this.set_payment_radio('bank');
  }

  initializeDefaultCurries = () => {
    const query_strings = queryString.parse(this.props.location.search);
    const fromLedger = parseInt(query_strings.fromLedger);
    this.setState({from_amount: 1000});
    // if (fromLedger)
    //   this.getLedgerBalances(fromLedger)

    // const query_strings = queryString.parse(this.props.location.search);
    const currency = parseInt(query_strings.fromCurrency);
    // const fromLedger = parseInt(query_strings.fromLedger);
    if (fromLedger) {
      this.props.updateNewTransferCreation('fromLedger', fromLedger);
    }
    this.props.updateNewTransferCreation('defaultFromCurrency', isNaN(currency) ? 1 : currency);
    this.props.updateNewTransferCreation('amount_lock', 'from_amount');
    this.props.updateNewTransferCreation('amount_from', '1000');
    this.handleAmount('to_amount');
    this.defaultCurrencies(
      'from_currency',
      this.props.app_state.current_team &&
        (this.props.app_state.current_team.defaultFromCurrency || isNaN(currency) ? 1 : currency)
    );
    this.defaultCurrencies(
      'to_currency',
      this.props.app_state.current_team && (this.props.app_state.current_team.defaultToCurrency || 5)
    );
    this.changeDefault('1000', 'from_amount', 'isLargerThanNumber', min_transfer_amount);
    this.setState({});
    this.getLedgerBalances();
  };

  changeDefault(event, stateName, type, stateNameEqualTo) {
    switch (type) {
      case 'email':
        if (this.verifyEmail(event)) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + '_state']: 'error'});
        }
        break;
      case 'length':
        if (this.verifyLength(event, stateNameEqualTo)) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + '_state']: 'error'});
        }
        break;
      case 'password':
        if (this.verifyLength(event, 1)) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + ' _state']: 'error'});
        }
        break;
      case 'equalTo':
        if (this.compare(event, this.state[stateNameEqualTo])) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + '_state']: 'error'});
        }
        break;
      case 'isLargerThanNumber':
        if (this.isLargerThanNumber(event, stateNameEqualTo)) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + '_state']: 'error'});
        }
        break;
      default:
        break;
    }
    this.setState({[stateName]: event});
    // Calculate "to amount"
    if (stateName === 'from_amount') {
      this.setState({last_user_type_amount_name: 'from_amount'});
      this.props.updateNewTransferCreation('amount_from', event);
      this.handleAmount('to_amount');
    }
    // Calculate "from amount"
    if (stateName === 'to_amount') {
      this.setState({last_user_type_amount_name: 'to_amount'});
      this.props.updateNewTransferCreation('amount_to', event);
      this.handleAmount('from_amount');
    }
    // if (stateName === "amount_to") {
    //   this.fetchNewRate()
    // }
  }

  defaultCurrencies = (name, option_value) => {
    this.setState({[name]: option_value}, () => {
      switch (this.state.last_user_type_amount_name) {
        case 'from_amount':
          this.handleAmount('to_amount');
          break;
        case 'to_amount':
          this.handleAmount('from_amount');
          break;
        default:
          this.handleAmount();
      }
    });
    this.setState({[name + '_state']: 'success'});

    // console.log(name);
    if (name === 'from_currency') {
      // console.log(this.state);
      this.props.updateNewTransferCreation('currency_from_id', option_value);
      this.props.updateNewTransferCreation('currency_from_state', 'success');
      API.get('currencies', `/get/${option_value}`)
        .then(response => {
          this.props.updateNewTransferCreation('currency_from', response);
          this.props.updateNewTransferCreation('currency_from_name', response.iso_alpha_3);
        })
        .catch(error => {
          console.log(error);
        });
    }
    if (name === 'to_currency') {
      // console.log("==do something==");
      // console.log(this.state);
      this.props.updateNewTransferCreation('currency_to_id', option_value);
      this.props.updateNewTransferCreation('currency_to_state', 'success');
      API.get('currencies', `/get/${option_value}`)
        .then(response => {
          this.props.updateNewTransferCreation('currency_to', response);
          this.props.updateNewTransferCreation('currency_to_name', response.iso_alpha_3);
        })
        .catch(error => {
          console.log(error);
        });
    }
  };

  queryStrings() {
    const query_strings = queryString.parse(this.props.location.search);
    if (Object.keys(query_strings).length !== 0) {
      if (query_strings.client_id) {
        if (query_strings.from_amount) {
          this.getClientDetails(Number(query_strings.client_id), 'handleToAmount', query_strings);
        }
        if (query_strings.to_amount) {
          this.getClientDetails(Number(query_strings.client_id), 'handleFromAmount', query_strings);
        }
      }
    }
  }

  getClientDetails(client_id, option, query_strings) {
    API.get('clients', `/get/id/${client_id}`)
      .then(response => {
        this.props.updateNewTransferCreation('client', response);
        if (option === 'handleToAmount') {
          this.setState(
            {
              from_currency: Number(query_strings.from_currency),
              from_currency_state: 'success',
              to_currency: Number(query_strings.to_currency),
              to_currency_state: 'success',
              from_amount: query_strings.from_amount,
              from_amount_state: 'success',
              last_user_type_amount_name: 'from_amount'
            },
            () => {
              this.handleAmount('to_amount');
            }
          );
        }
        if (option === 'handleFromAmount') {
          this.setState(
            {
              from_currency: Number(query_strings.from_currency),
              from_currency_state: 'success',
              to_currency: Number(query_strings.to_currency),
              to_currency_state: 'success',
              to_amount: query_strings.to_amount,
              to_amount_state: 'success',
              last_user_type_amount_name: 'to_amount'
            },
            () => {
              this.handleAmount('from_amount');
            }
          );
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  getBeneficiaryDetails(beneficiary_id) {
    API.get('beneficiaries', `/get/id/${beneficiary_id}`)
      .then(response => {
        this.setState({beneficiary: response[0]});
        this.props.updateNewTransferCreation('beneficiary', response[0]);

        this.setState({
          beneficiary: {
            ...this.state.beneficiary,
            account_currency_nickname: `${response[0].full_name} [${response[0].iso_alpha_3}]`
          }
        });

        return response;
      })
      .then(response => {
        API.get('system', `/currencies/get/${response[0].account_currency}`)
          .then(response => {
            this.setState({
              beneficiary: {
                ...this.state.beneficiary,
                account_currency_nickname: `${response.full_name} [${response.iso_alpha_3}]`
              }
            });
            this.props.updateNewTransferCreation('currency_to_id', response.id);
            this.props.updateNewTransferCreation('currency_to', response);

            API.post('email', '/interaction/main', {
              body: {
                interaction: 'New Transfer Request Step 2 PayingTo',
                data: {
                  client_id: this.props.app_state.current_client.id,
                  client_nickname: this.props.app_state.current_client.nickname,
                  beneficiary_id: this.state.beneficiary.id,
                  beneficiary_nickname: this.state.beneficiary.nickname
                },
                result: 'New transfer request proceeding'
              }
            });
          })
          .catch(error => {
            console.log(error);
          });
      })
      .catch(error => {
        console.log(error);
      });
  }

  fetchNewRate = () => {
    if (
      this.props.transfers_2.new_transfer_data.to_currency &&
      this.props.transfers_2.new_transfer_data.from_currency
    ) {
      const url = 'https://apilayer.net/api/live?access_key=a4eb7fd0501842eb4d4712cc459cae5f';
      axios
        .get(url, {
          params: {
            currencies: this.props.transfers_2.new_transfer_data.from_currency.iso_alpha3,
            source: this.props.transfers_2.new_transfer_data.to_currency.iso_alpha3,
            format: '1'
          }
        })
        .then(response => {
          const key = `${this.props.transfers_2.new_transfer_data.currency_to.iso_alpha_3.toUpperCase()}${this.props.transfers.new_transfer_data.currency_from.iso_alpha_3.toUpperCase()}`;
          const rate_string = response.data.quotes[key];

          const amount_to = Number.parseFloat(this.props.transfers_2.new_transfer_data.amount_to);
          const rate = Number.parseFloat(rate_string);
          const rate_adjust =
            Number.parseFloat(this.props.app_state.current_client.default_rate_division) +
            Number.parseFloat(this.props.app_state.current_client.default_rate_entity) +
            Number.parseFloat(this.props.app_state.current_client.default_rate_team) +
            Number.parseFloat(this.props.app_state.current_client.default_rate_staff);
          const adjusted_rate = rate + rate * rate_adjust;
          console.log('--------------32132132132132132132123', rate_adjust);
          const amount_from = amount_to * adjusted_rate;

          this.props.updateNewTransferCreation('current_rate', adjusted_rate.toFixed(5));
          this.props.updateNewTransferCreation('amount_from', amount_from.toFixed(5));
        })
        .catch(error => {
          console.log(error);
        });
    }
  };

  sendState() {
    return this.state;
  }

  // function that verifies if two strings are equal
  compare(string1, string2) {
    if (string1 === string2) {
      return true;
    }
    return false;
  }

  // function that returns true if value is email, false otherwise
  verifyEmail(value) {
    const emailRex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }

  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }

  // function that verifies if a value is larger than a number or not
  isLargerThanNumber(value, number) {
    if (value !== '' && value >= number) {
      return true;
    }
    return false;
  }

  change(event, stateName, type, stateNameEqualTo) {
    switch (type) {
      case 'email':
        if (this.verifyEmail(event.target.value)) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + '_state']: 'error'});
        }
        break;
      case 'length':
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + '_state']: 'error'});
        }
        break;
      case 'password':
        if (this.verifyLength(event.target.value, 1)) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + ' _state']: 'error'});
        }
        break;
      case 'equalTo':
        if (this.compare(event.target.value, this.state[stateNameEqualTo])) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + '_state']: 'error'});
        }
        break;
      case 'isLargerThanNumber':
        if (this.isLargerThanNumber(event.target.value, stateNameEqualTo)) {
          this.setState({[stateName + '_state']: 'success'});
        } else {
          this.setState({[stateName + '_state']: 'error'});
        }
        break;
      default:
        break;
    }
    this.setState({[stateName]: event.target.value});
    // Calculate "to amount"
    if (stateName === 'from_amount') {
      this.setState({last_user_type_amount_name: 'from_amount'});
      this.props.updateNewTransferCreation('amount_from', event.target.value);
      this.handleAmount('to_amount');
    }
    // Calculate "from amount"
    if (stateName === 'to_amount') {
      this.setState({last_user_type_amount_name: 'to_amount'});
      this.props.updateNewTransferCreation('amount_to', event.target.value);
      this.handleAmount('from_amount');
    }
  }

  handleAmount(amount_name) {
    let from_currency_Iso = 'AUD';
    let to_currency_Iso = 'USD';

    this.state.currencies_list_priority.map((item, index) => {
      if (item.id == this.state.from_currency) {
        from_currency_Iso = item.iso_alpha_3;
      }
      if (item.id == this.state.to_currency) {
        to_currency_Iso = item.iso_alpha_3;
      }
    });

    const url = 'https://apilayer.net/api/live?access_key=a4eb7fd0501842eb4d4712cc459cae5f';
    axios
      .get(url, {
        params: {
          currencies: to_currency_Iso,
          source: from_currency_Iso,
          format: '1'
        }
      })
      .then(response => {
        const key = from_currency_Iso + to_currency_Iso;
        const rate_string = response.data.quotes[key];

        const rate = Number.parseFloat(rate_string);
        const rate_adjust =
          Number.parseFloat(this.props.transfers_2.new_transfer_data.client.default_rate) +
          Number.parseFloat(this.props.transfers_2.new_transfer_data.client.default_rate_division) +
          Number.parseFloat(this.props.transfers_2.new_transfer_data.client.default_rate_entity) +
          Number.parseFloat(this.props.transfers_2.new_transfer_data.client.default_rate_team) +
          Number.parseFloat(this.props.transfers_2.new_transfer_data.client.default_rate_staff);
        let adjusted_rate = rate - rate * rate_adjust;
        // Add Credit Card Rate Adjustment
        if (this.props.transfers_2.new_transfer_data.payment_method === 'worldpay') {
          adjusted_rate = adjusted_rate - adjusted_rate * WORLDPAY_ADJUSTMENT;
        }

        if (this.state.from_currency == this.state.to_currency) {
          adjusted_rate = rate;
        }

        this.props.updateNewTransferCreation('client_rate', adjusted_rate.toFixed(5));

        if (this.state.from_currency_state === 'success' && this.state.to_currency_state === 'success') {
          // handle to_amount
          if (amount_name === 'to_amount' && this.state.from_amount_state === 'success') {
            const amount_from = Number.parseFloat(this.state.from_amount);
            const amount_to = amount_from * adjusted_rate;

            this.setState({to_amount: amount_to.toFixed(2)});
            this.props.updateNewTransferCreation('amount_to', amount_to.toFixed(2));
            if (amount_to >= min_transfer_amount) {
              this.setState({to_amount_state: 'success'});
            } else {
              this.setState({to_amount_state: 'error'});
            }
          }

          // handle from_amount
          if (amount_name === 'from_amount' && this.state.to_amount_state === 'success') {
            const amount_to = Number.parseFloat(this.state.to_amount);
            const amount_from = amount_to / adjusted_rate;
            this.props.updateNewTransferCreation('amount_to', amount_to.toFixed(2));
            this.setState({from_amount: amount_from.toFixed(2)});
            this.props.updateNewTransferCreation('amount_from', amount_from.toFixed(2));
            if (amount_from >= min_transfer_amount) {
              this.setState({from_amount_state: 'success'});
            } else {
              this.setState({from_amount_state: 'error'});
            }
          }
        }

        this.setState({adjusted_rate: adjusted_rate});
      })
      .catch(error => {
        console.log(error);
      });
  }

  handleCustomReactSelectChange = (name, previous_from_currency, previous_to_currency) => value => {
    let option_value;
    if (value === null) {
      option_value = null;
    } else {
      option_value = value.value;
    }

    this.setState({[name]: option_value}, () => {
      switch (this.state.last_user_type_amount_name) {
        case 'from_amount':
          this.handleAmount('to_amount');
          break;
        case 'to_amount':
          this.handleAmount('from_amount');
          break;
        default:
          this.handleAmount();
      }
    });
    this.setState({[name + '_state']: 'success'});

    if (name === 'from_currency') {
      this.props.updateNewTransferCreation('currency_from_id', option_value);
      this.props.updateNewTransferCreation('currency_from_state', 'success');
      API.get('currencies', `/get/${option_value}`)
        .then(response => {
          this.props.updateNewTransferCreation('currency_from', response);
          this.props.updateNewTransferCreation('currency_from_name', response.iso_alpha_3);
        })
        .catch(error => {
          console.log(error);
        });
    }
    if (name === 'to_currency') {
      this.props.updateNewTransferCreation('ledgerTo', false);
      this.props.updateNewTransferCreation('currency_to_id', option_value);
      this.props.updateNewTransferCreation('currency_to_state', 'success');
      API.get('currencies', `/get/${option_value}`)
        .then(response => {
          this.props.updateNewTransferCreation('currency_to', response);
          this.props.updateNewTransferCreation('currency_to_name', response.iso_alpha_3);
        })
        .catch(error => {
          console.log(error);
        });
    }
  };

  set_payment_radio = value => {
    this.setState({payment_method: value});
    this.props.updateNewTransferCreation('payment_method', value);
    this.handleAmount('from_amount');
  };

  isValidated() {
    if (this.state.from_currency_state !== 'success') {
      this.setState({from_currency_state: 'error'});
    }
    if (this.state.to_currency_state !== 'success') {
      this.setState({to_currency_state: 'error'});
    }
    if (this.state.from_amount_state !== 'success') {
      this.setState({from_amount_state: 'error'});
    }
    if (this.state.to_amount_state !== 'success') {
      this.setState({to_amount_state: 'error'});
    }

    if (
      this.state.from_currency_state === 'success' &&
      this.state.to_currency_state === 'success' &&
      this.state.from_amount_state === 'success' &&
      this.state.to_amount_state === 'success'
    ) {
      API.get('system', `/currencies/get/${this.state.from_currency}`)
        .then(response => {
          console.log(response);
          this.props.updateNewTransferCreation('currency_from', response);
          //#1090
          this.props.updateNewTransferCreation('remitting_bank_account_id', response.primary_bank_account_id);
          API.get('system', `/entitybanksaccount/get/id/${response.primary_bank_account_id}`)
            .then(response => {
              console.log(response);
              this.props.updateNewTransferCreation('remitting_bank_account_detail', response);

              API.get('system', `/entitybanks/get/id/${response.entity_bank_id}`)
                .then(response => {
                  console.log(response);
                  this.props.updateNewTransferCreation('remitting_bank_detail', response);
                  //#1090
                  this.props.updateNewTransferCreation(
                    'remitting_bank_id',
                    this.props.transfers_2.new_transfer_data.remitting_bank_account_detail[0].entity_bank_id
                  );
                })
                .catch(error => {
                  console.log(error);
                });
            })
            .catch(error => {
              console.log(error);
            });

          API.get('system', `/currencies/get/${this.state.to_currency}`)
            .then(response => {
              this.props.updateNewTransferCreation('currency_to', response);
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(error => {
          console.log(error);
        });

      this.props.updateNewTransferCreation('currency_from_id', this.state.from_currency);
      this.props.updateNewTransferCreation('currency_to_id', this.state.to_currency);
      this.props.updateNewTransferCreation('amount_from', this.state.from_amount);
      this.props.updateNewTransferCreation('amount_to', this.state.to_amount);
      this.props.updateNewTransferCreation('client_rate', this.state.adjusted_rate);

      return true;
    }

    return false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.transfers_2.new_transfer_data.client && this.state.reRender) {
      this.initializeDefaultCurries();
      this.setState({reRender: false});
    }
  }

  set_payment_radio_second = e => {
    e.preventDefault();
    this.setState({payment_method: e.target.value});
    this.props.updateNewTransferCreation('payment_method', e.target.value);
    this.handleAmount('from_amount');
  };

  getLedgerBalances = () => {
    // console.log('getLedgerBalances')
    API.get('holding_accounts', `/get/client_id/${this.props.transfers_2.new_transfer_data.client.id}`)
      .then(response => {
        console.info('holdingAccounts', response);
        this.setState({holdingAccountBalances: response.holding_account_list});

        // const {holding_account_list} = response;
        // if (holding_account_list.length > 0) {
        //   this.setState({
        //     holdingAccount: response.holding_account_list[0]
        //   });
        // }
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateLedgerAmount = async (stateName, value) => {
    this.setState({[stateName]: value});
    this.props.updateNewTransferCreation(stateName, value);

    if (stateName == 'ledgerTo') {
      if (value) {
        const clientId = this.props.transfers_2.new_transfer_data.client.id;
        const currencyId = this.props.transfers_2.new_transfer_data.currency_to_id;
        const response = await API.get('holding_accounts', `/get/client-currency/${clientId}/${currencyId}`);
        console.log(response);
        this.setState({
          send_to_holding_acc_checkbox: value,
          [stateName]: response.holding_account_list[0].id
        });
        this.props.updateNewTransferCreation('ledgerTo', response.holding_account_list[0].id);
        this.props.updateNewTransferCreation('send_to_holding_acc_checkbox', value);
      } else {
        this.setState({
          send_to_holding_acc_checkbox: value,
          ledgerTo: value
        });
        this.props.updateNewTransferCreation('ledgerTo', value);
        this.props.updateNewTransferCreation('send_to_holding_acc_checkbox', value);
      }
    }
  };

  render() {
    const {classes} = this.props;
    // For CustomReactSelect. Generate select options for dropdown list.
    const select_currency_select_options = this.state.currencies_list_priority.map(item => ({
      value: item.id,
      label: item.iso_alpha_3
    }));

    const checkledger = record => {
      // const query_strings = queryString.parse(this.props.location.search);
      // const fromLedger = parseInt(query_strings.fromLedger);
      // if (!isNaN(fromLedger) && parseInt(this.state.from_amount) > record.balance) {
      //   return 'You have entered an amount higher than the available';
      // } else {
      //   return '';
      // }
      if (
        parseFloat(this.props.transfers_2.new_transfer_data.amount_from) > record.balance &&
        this.props.transfers_2.new_transfer_data.ledgerFrom
      ) {
        if (!this.props.transfers_2.new_transfer_data.disable) {
          this.props.updateNewTransferCreation('disable', true);
        } else if (this.props.transfers_2.new_transfer_data.disable == false) {
          this.props.updateNewTransferCreation('disable', true);
        }
        if (this.props.transfers_2.new_transfer_data.ledgerFrom) {
          this.setState({ledgerFrom: false});
          this.updateLedgerAmount('ledgerFrom', false);
        }
        return 'You have entered an amount higher than your available balance';
      }
      if (this.props.transfers_2.new_transfer_data.disable == true) {
        this.props.updateNewTransferCreation('disable', false);
      }
    };

    let fromCurrencyLedgerChip = <Chip icon={<React.Fragment> Ledger Balance: 0.00</React.Fragment>} />;

    for (const idx in this.state.holdingAccountBalances) {
      const record = this.state.holdingAccountBalances[idx];
      if (record.currency_id === this.props.transfers_2.new_transfer_data.currency_from_id) {
        fromCurrencyLedgerChip = (
          <React.Fragment>
            <p
              style={{
                textAlign: 'right',
                textTransform: 'capitalize',
                fontWeight: 'bold',
                color: 'red'
              }}
            >
              {checkledger(record)}
            </p>
            <Chip
              label={
                <div>
                  <Checkbox
                    tabIndex={-1}
                    disabled={parseFloat(this.props.transfers_2.new_transfer_data.amount_from) > record.balance}
                    // disabled={this.disableCheckBox(
                    //   "amount_from",
                    //   record,
                    //   "ledgerFrom"
                    // )}
                    onClick={e => this.updateLedgerAmount('ledgerFrom', e.target.checked ? record.id : null)}
                    checked={
                      Boolean(this.state.ledgerFrom) || Boolean(this.props.transfers_2.new_transfer_data.ledgerFrom)
                    }
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked,
                      root: classes.checkRoot
                    }}
                  />
                  Click to transfer from {record.currencies_short_name} Ledger. Current balance&nbsp;
                  {new Intl.NumberFormat('en-GB', {
                    style: 'currency',
                    currency: record.currencies_short_name
                  }).format(record.balance)}
                  <br />
                </div>
              }
            />
          </React.Fragment>
        );
      }
    }

    // fromCurrencyLedgerChip = (
    //   <React.Fragment>
    //     {this.state.holdingAccount &&
    //       <Chip
    //         label={
    //           <div>
    //             Current balance&nbsp;
    //             {new Intl.NumberFormat('en-GB', {
    //               style: 'currency',
    //               currency: this.state.holdingAccount.currencies_short_name
    //             }).format(this.state.holdingAccount.balance)}
    //             <span
    //               style={{
    //                 textTransform: 'capitalize',
    //                 fontWeight: 'bold',
    //                 color: 'red'
    //               }}
    //             >
    //             &nbsp;&nbsp; {this.state.holdingAccount && checkledger(this.state.holdingAccount)}
    //             </span>
    //             <br />
    //           </div>
    //         }
    //       />}
    //   </React.Fragment>
    // );

    return (
      <React.Fragment>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={12}>
            <h4 className={classes.infoText} />
          </GridItem>
        </GridContainer>
        <GridContainer
          justify='flex-start'
          style={{
            maxWidth: '100%',
            flexBasis: '100%'
          }}
        >
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              {this.props.app_state.current_team && this.props.app_state.current_team.brand_transfer_payeeFirst ? (
                <CommoneCurrentComponent
                  color='yellow'
                  selectLabel='To Currency'
                  selectOptions={select_currency_select_options}
                  selectValue={this.state.to_currency}
                  isClearable={false}
                  isDisabled={this.state.prefill_to_currency}
                  inputValue2={this.state.to_amount}
                  onSelectChange={this.handleCustomReactSelectChange('to_currency')}
                  inputValue='Beneficiary gets'
                  onInputChange={event => {
                    this.change(event, 'to_amount', 'isLargerThanNumber', min_transfer_amount);
                  }}
                />
              ) : (
                <CommoneCurrentComponent
                  selectLabel='From Currency'
                  defaultValue={1000}
                  color='blue'
                  selectOptions={select_currency_select_options}
                  selectValue={this.state.from_currency}
                  isClearable={false}
                  onSelectChange={this.handleCustomReactSelectChange('from_currency')}
                  inputValue='You send'
                  inputValue2={this.state.from_amount}
                  onInputChange={event => {
                    this.change(event, 'from_amount', 'isLargerThanNumber', min_transfer_amount);
                  }}
                />
              )}
            </GridContainer>
            {/* {fromCurrencyLedgerChip} */}
            {this.props.transfers_2.new_transfer_data.teamClientId && <span>TEAM CLIENT ID</span>}
            <br />

            <GridContainer>
              <GridItem xs={8} sm={8} md={7}>
                <p className={classes.transferRate}>
                  {!isNaN(this.state.adjusted_rate)
                    ? 'Transfer Rate: ' + Number.parseFloat(this.state.adjusted_rate).toFixed(5)
                    : ''}
                </p>
              </GridItem>
              <GridItem xs={8} sm={8} md={5}>
                <div className={classes.selectContainer}>
                  <GridContainer justify='center' style={{marginBottom: '1px'}}>
                    <GridItem xs={3} md={3} className={classes.cardImg}>
                      <img src={cardPng} alt='' />
                    </GridItem>
                    <GridItem xs={9} md={9} style={{paddingLeft: '0'}}>
                      <span className={classes.paymentMethod}>Choose a payment method:</span>
                    </GridItem>
                  </GridContainer>
                  <GridContainer justify='center'>
                    <GridItem xs={12} sm={12}>
                      <select
                        name='cars'
                        id='cars'
                        className={classes.transactionOptions}
                        defaultChecked={this.state.payment_method}
                        onChange={this.set_payment_radio_second.bind(this)}
                      >
                        <option value='bank'>Bank Transfer (EFT)</option>
                        {/* <option value="worldpay">Credit Card</option> */}
                      </select>
                    </GridItem>
                    {/* <GridItem xs={1} sm={1} /> */}
                  </GridContainer>
                </div>
              </GridItem>
            </GridContainer>

            <br />
            <GridContainer>
              {this.props.app_state.current_team && this.props.app_state.current_team.brand_transfer_payeeFirst ? (
                <CommoneCurrentComponent
                  selectLabel='From Currency'
                  defaultValue={1000}
                  color='blue'
                  selectOptions={select_currency_select_options}
                  selectValue={this.state.from_currency}
                  isClearable={false}
                  onSelectChange={this.handleCustomReactSelectChange('from_currency')}
                  inputValue='You send'
                  inputValue2={this.state.from_amount}
                  onInputChange={event => {
                    this.change(event, 'from_amount', 'isLargerThanNumber', min_transfer_amount);
                  }}
                />
              ) : (
                <CommoneCurrentComponent
                  color='yellow'
                  selectLabel='To Currency'
                  selectOptions={select_currency_select_options}
                  selectValue={this.state.to_currency}
                  isClearable={false}
                  isDisabled={this.state.prefill_to_currency}
                  inputValue2={this.state.to_amount}
                  onSelectChange={this.handleCustomReactSelectChange('to_currency')}
                  inputValue='Beneficiary gets'
                  onInputChange={event => {
                    this.change(event, 'to_amount', 'isLargerThanNumber', min_transfer_amount);
                  }}
                />
              )}
            </GridContainer>
          </GridItem>{' '}
        </GridContainer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    app_state: state.app_state,
    transfers_2: state.transfers_2
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateNewTransferCreation: (key, value) => {
      dispatch(updateNewTransferCreation(key, value));
    }
  };
};

const Step2TransferContainer = connect(mapStateToProps, mapDispatchToProps)(Step2Transfer);

export default withRouter(withStyles(style)(Step2TransferContainer));
